export const NOTIFICATION_INTERVAL_DELAY = 1000 * 60;
